<template>
    <div>
        <h2 class="gallery_title">{{translations.showImages}} <span>({{images.length}})</span></h2>
        <section class="gallery">
            <div class="gallery_item add_item">
                <div class="gallery_item_image">
                    <label for="addImage" class="add_image" :title="translations.uploadImage" v-translate>Nahrát obrázky</label>
                    <input
                            id="addImage"
                            class="input_file"
                            type="file"
                            multiple
                            name="addImage"
                            @change="processFile($event)"
                    >
                </div>
            </div>
            <template v-if="!pending || reloading">
                <template v-for="image in images">
                    <div class="gallery_item" :key="image._id">
                        <div class="gallery_item_image" :class="{ 'checked': image.portrait || image.landscape }">
                            <p class="gallery_item_image_inner">
                                <img :src="image.imageLink">
                            </p>
                            <p v-if="!image.portrait || !image.landscape" class="photo_switch_overlay">
                                <a
                                        v-if="!image.portrait"
                                        class="photo_switch portrait_switch"
                                        @click.prevent="setPrimaryType(image._id, 'portrait')"
                                        :title="translations.setAsPrimaryPortrait"
                                >Portrait</a>
                                <a
                                        v-if="!image.landscape"
                                        class="photo_switch landscape_switch"
                                        @click.prevent="setPrimaryType(image._id, 'landscape')"
                                        :title="translations.setAsPrimaryLandscape"
                                >Landscape</a>
                            </p>
                            <p
                                    v-if="image.portrait && !image.landscape"
                                    class="checked_indicator"
                            >Portrait</p>
                            <p
                                    v-if="image.landscape && !image.portrait"
                                    class="checked_indicator"
                            >Landscape</p>
                            <p
                                    v-if="image.landscape && image.portrait"
                                    class="checked_indicator"
                            >Portait + Landscape</p>
                            <p
                                    class="btn btn_action btn_delete"
                                    :title="translations.delete"
                                    @click.prevent="imageDelete(image._id)"
                                    v-translate
                            >Smazat</p>
                        </div>
                        <p class="gallery_item_desc"></p>
                    </div>
                </template>
            </template>
        </section>
        <h2 class="gallery_title">{{translations.broadcastImages}} <span>({{broadcastImages.length}})</span></h2>
        <section class="gallery">
            <template v-if="!pending || reloading">
                <template v-for="image in broadcastImages">
                    <div class="gallery_item" :key="image._id">
                        <div class="gallery_item_image">
                            <p class="gallery_item_image_inner">
                                <img :src="image.imageLink">
                            </p>
                            <p v-if="!image.portrait || !image.landscape" class="photo_switch_overlay">
                                <a
                                    class="photo_switch portrait_switch"
                                    @click.prevent="copyFromBroadcastSetPrimaryType(image._id, 'portrait')"
                                    :title="translations.setAsPrimaryPortrait"
                                >Portrait</a>
                                <a
                                    class="photo_switch landscape_switch"
                                    @click.prevent="copyFromBroadcastSetPrimaryType(image._id, 'landscape')"
                                    :title="translations.setAsPrimaryLandscape"
                                >Landscape</a>
                            </p>
                        </div>
                    </div>
                </template>
            </template>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import { setLoadingMessage, showErrorWithTimeout } from '../../../utils/form'
import { showDeleteDialog } from '../../../utils/dialog'
import { VUE_APP_BASE_API_URL } from '../../../constants/fileConstants'
import formatDateMixin from 'mixins/formatDateMixin'

export default {
  name: 'images',
    mixins: [formatDateMixin],
  props: {
    parentName: {
        type: String,
        default: ''
    },
    parentId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedImage: null,
      imagesUploading: false,
      reloading: false,
      readyForUpload: false
    }
  },
  computed: {
    ...mapState({
      images: state => state.images.images,
      broadcastImages: state => state.images.broadcastImages,
      pending: state => state.images.pending.images,
      allTvStations: state => state.tvStations.allTvStations
    }),
    translations() {
      return {
        uploadImage: this.$gettext('Nahrát obrázky'),
        setAsPrimaryPortrait: this.$gettext('Nastavit jako primární portrét'),
        setAsPrimaryLandscape: this.$gettext('Nastavit jako primární landscape'),
        delete: this.$gettext('Smazat'),
        uploadingImages: this.$gettext('Nahrávání obrázků...'),
        maxSize: this.$gettext('Maximální velikost obrázku'),
        notAnImage: this.$gettext('Obrázek musí být typu "jpeg" nebo "png"'),
        showImages: this.$gettext('Obrázky k pořadu'),
        broadcastImages: this.$gettext('Obrázky k vysílání'),
      }
    }
  },
  methods: {
    ...mapActions([
      'createImage',
      'updateImage',
      'deleteImage',
        'copyBroadcastImageToShow',
        'getImages'
    ]),
    getTvStationName(id) {
        return this.allTvStations.find(t => t._id === id).name
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? this.translations.uploadingImages : null)
    },
    setReloading(reloading) {
      this.reloading = reloading
    },
    setReadyForUpload(readyForUpload) {
      this.readyForUpload = readyForUpload
    },
    validate(file) {
      const MAX_SIZE = 20000000
      const allowedTypes = ['image/jpeg', 'image/png']

      if (file.size > MAX_SIZE) {
        return `${this.translations.maxSize}: ${MAX_SIZE / 1000000}MB`
      }

      if (!allowedTypes.includes(file.type)) {
        return this.translations.notAnImage
      }

      return ''
    },
    async processFile(event) {
      const imageApiUrl = VUE_APP_BASE_API_URL + 'images/'
      const formData = new FormData()

      try {
        this.setImagesUploading(true)

        const imageFiles = event.target.files
        formData.set('parentId', this.parentId)
        formData.append('parentName', this.parentName)
        for (var i = 0; i < imageFiles.length; i++) {
          const imageFile = imageFiles[i]
          const validationResponse = this.validate(imageFile)

          if (validationResponse === '') {
            this.setReadyForUpload(true)
            formData.append('files[' + i + ']', imageFile)
          } else {
            showErrorWithTimeout(this, validationResponse)
          }
        }
        if (this.readyForUpload) {
          await axios.post(imageApiUrl, formData)
        }
      } finally {
        if (this.readyForUpload) {
          this.refreshImages()
        }
        this.setReadyForUpload(false)
        this.setImagesUploading(false)
      }
    },
    async imageDelete(targetId) {
      try {
        showDeleteDialog(this, {
          apiMethod: 'deleteImage',
          params: {
            parentName: this.parentName,
            id: targetId
          }
        }, null)
      } finally {
        this.refreshImages()
      }
    },
      async setPrimaryType(targetId, setType) {
          try {
              await this.updateImage({
                  params: {
                      parentName: this.parentName,
                      parentId: this.parentId,
                      id: targetId,
                      primaryType: setType
                  }
              })
          } finally {
              this.refreshImages()
          }
      },
      async copyFromBroadcastSetPrimaryType(imageRelationshipId, setType) {
          try {
              await this.copyBroadcastImageToShow({
                  params: {
                      imageRelationshipId: imageRelationshipId,
                      showId: this.parentId,
                      primaryType: setType
                  }
              })
          } finally {
              this.refreshImages()
          }
      },
    async refreshImages() {
      try {
        this.setReloading(true)
        await this.getImages({
          params: {
            parentName: this.parentName,
            parentId: this.parentId
          }
        })
      } finally {
        this.setReloading(false)
      }
    }
  }
}
</script>
